/**
 * Adjuntos de solicutud de pago
 *
 */
import React from 'react'
import { Table, Button, Modal } from 'antd'
import moment from 'moment'
import numeral from 'numeral'
import Cell from '../../../components/Cell'
import Api from '../../../Api'
import Exception from '../../../Exception'

export default class Pagos extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    // this.requestNewFile(record, record.sFiltro)
    this.columns = Cell.buildList([
      { width: '20%', title: 'IMPORTE', dataIndex: 'dImporte', render: val => numeral(val).format('$0,0.00') },
      { width: '15%', title: 'FECHA', dataIndex: 'pago.dKernelFechaRegistro', render: val => moment(val).format('YYYY-MM-DD HH:mm:ss') },
      { width: '15%', title: 'STATUS', dataIndex: 'pago.sEstado' },
      { width: '20%', title: 'FECHA PAGO', dataIndex: 'pago.dFechaPago', render: val => val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '-' },
      { width: '15%', title: 'CHEQUE', dataIndex: 'pago.sNumeroCheque', render: val => val || '-' },
      { width: '15%', title: 'TRANSFERENCIA', dataIndex: 'pago.sNumeroTransferencia', render: val => val || '-' },
    ])

    this.state = {
      templates: [],
      data: [],
      loading: false,
      solicitudId: 0,
    }
  }

  /**
   * Load
   *
   * @param {Number} solicitudId
   */
  load = (solicitudId) => {
    this.setState({
      visible: true,
      loading: true,
      data: [],
      solicitudId,
    })

    const query = {
      attributes: ['iId', 'dImporte'],
      model: 'TesPagoFactura',
      include: [{
        as: 'pago',
        attributes: [
          'iId',
          'dKernelFechaRegistro',
          'dFechaPago',
          'sEstado',
          'sNumeroCheque',
          'sNumeroTransferencia',
        ],
      }],
      where: {
        iIdFactura: solicitudId
      }
    }

    Api.query(query)
      .then(response =>
        this.setState({
          loading: false,
          data: response.data,
        })
      )
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   * Render
   *
   */
  render() {
    return (
      <Modal
        title='PAGOS AUTORIZADOS'
        visible={this.state.visible}
        onOk={this.onSave}
        style={{ minWidth: '70%' }}
        onCancel={() => this.setState({ visible: false })}
        footer={[
          <Button
            key='guardar'
            loading={this.state.loading}
            onClick={() => this.setState({ visible: false })}
            children='Cerrar'
          />
        ]}
        children={
          <Table
            key='2'
            rowKey='iId'
            size='small'
            loading={this.state.loading}
            columns={this.columns}
            pagination={false}
            dataSource={this.state.data}
            bordered={false}
          />
        }
      />
    )
  }
}
